import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  children,
  className = ''
}) => {
  return (
    <div className={`sidebar-section ${className}`}>
      <div
        className="schedule-sidebar-header schedule-sidebar-header--collapsible"
        onClick={onToggle}
      >
        <h3 className="schedule-sidebar-title">{title}</h3>
        <button
          className="schedule-sidebar-toggle"
          aria-label={isExpanded ? 'Collapse' : 'Expand'}
        >
          {isExpanded ? (
            <ChevronUp className="icon icon--sm" />
          ) : (
            <ChevronDown className="icon icon--sm" />
          )}
        </button>
      </div>
      {isExpanded && (
        <div className="schedule-sidebar-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
